const baseURL = 'https://simuladorplanos-services-dev.azurewebsites.net/api';

export const environment = {
  production: false,
  development: true,
  baseURL,

  appVersion: require('../../package.json').version,
};
